import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  /* width: 1000px;
  height: 600px; */
  height: 100%;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin-left: 20px;
`;

export const CenterText = styled.div`
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  display: flex;
  font-family: Inter;
  font-size: 26px;
  font-weight: 500;
  line-height: 32px;
  color: #101828;
`;

export const Button = styled(IconButton)``;
